export default __webpack_public_path__ + "static/genetics-eaa60d29bb83b61dd7ca4d5422020445.jpg";